import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ClaimsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/claims", { params: toSnakeCase(params) });
  }

  fetch(claimFriendlyId, includes = []) {
    return securedAxiosInstance.get(`/claims/${claimFriendlyId}`, { params: { includes } });
  }

  getPaymentStripeUrl(claimId) {
    return securedAxiosInstance.get(`/claims/${claimId}/payment_link`);
  }

  uploadQuotation(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/upload_quotation`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  declareIrreparable(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/declare_irreparable`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  uploadInvoice(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/upload_invoice`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  fetchDeductibleInvoiceUrl(id) {
    return securedAxiosInstance.get(`/claims/claim_deductibles/${id}/invoice_url`);
  }

  // === Cost Items Extraction ===

  extractCostItems(claimId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return securedAxiosInstance.post(`/claims/${claimId}/extract_cost_items`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  // === Final Settlements ===

  fetchFinalSettlementInvoiceUrl(id) {
    return securedAxiosInstance.get(`/claims/final_settlements/${id}/invoice_url`);
  }

  // === Claim Invoices ===

  fetchClaimInvoices(params) {
    return securedAxiosInstance.get("/claims/invoices", { params: toSnakeCase(params) });
  }

  // === Claim Quotations ===

  fetchClaimQuotations(params) {
    return securedAxiosInstance.get("/claims/quotations", { params: toSnakeCase(params) });
  }
}

export default new ClaimsService();
